<template>
    <div class="mPage">
        <div class="top">
            <img src="../img/m/m_logo.png" alt="" class="logo">
            <span class="title">{{ $t("message.news") }}</span>
            <slot></slot>
        </div>
        <div class="content">
            <div class="firstHot" v-if="newsList.length>0" @click="toDetail(newsList[0])">
                <img
                    :src="'http://conference2019.hanban.org/upload/'+newsList[0].thumb"
                    v-if="newsList.length>0"
                    
                    :class="{ 'toWidth': newsList[0]['toWidth'] == true}"
                    alt
                />
                <div class="firstTitle">{{newsList[0].title}}</div>
            </div>
            <ul>
            <li v-for="(newsItem, index) in newsListArray" :key="index">
                <span @click="toDetail(newsItem)"> {{newsItem.title}}</span>
                <!-- <router-link :to="{path:'/pcpage/detailpage/newsdetail',query: {id: newsItem.id}}" active-class="activeLink">
                    {{newsItem.title}}
                </router-link> -->
            </li>
            </ul>
            <div class="moreNews">
                <router-link to="/m_page/m_detailpage/m_newslist" active-class="activeLink">
                    <span>{{ $t("message.more") }}</span>
                </router-link>
            </div>
        </div>
        <img src="../img/m/arrow_down.png" alt="" class="arrowDown">
    </div>
</template>

<script>
export default {
    name: 'm_news',
    components: {
        
    },
    data: function () {
        return {
            newsList: []
        }
    },
    computed: {
        newsListArray() {
            if(this.newsList.length > 6){
                return this.newsList.slice(1, 6)
            }else {
                return this.newsList.slice(1, this.newsList.length-1)
            }
        
        },
        language() {
            return this.$i18n.locale
        }
    },
    methods: {
    getAllList() {
      this.$utils
        .get("hotspot/api/getAllList", {
          lang: 'cn'
        })
        .then(res => {
          this.newsList = res.data.data.list;
        });
    },
    toDetail(item) {
        //this.$router.push(item.link)
        window.open(item.link)
    }
  },
    watch: {
      // 监听切换语言
      language (newval, old) {
          //this.getAllList()
      }
    },
  mounted() {
    this.getAllList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mPage {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .top {
        height: 1.4rem;
        line-height: 1.4rem;
        position: relative;
        .logo {
            width: 1.27rem;
            margin: auto 0.34rem;
            vertical-align: middle;
        }
        .title {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
            width: 1.93rem;
            display: inline-block;
            text-align: center;
            font-size: 0.46rem;
            white-space: nowrap;
            color: #f3bc65;

        }
        .menu {
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            right: 0.34rem;
            width: 0.51rem;
            vertical-align: middle;
        }
    }
    .content {
        text-align: center;
        .firstHot {
            position: relative;
            text-align: left;
            img {
                width: 100%;
            }
            .firstTitle {
                position: absolute;
                bottom: 0.35rem;
                color: #fff;
                font-size: 0.36rem;
                width: 90%;
                margin: 0 4%;
                line-height: 1.2;
                opacity: 0.8;
                font-weight: bold;
            }
        }
        ul {
            margin-top: 0.2rem;
            text-align: left;
            li {
                width: 85%;
                font-size: 0.28rem;
                padding: 0.2rem 0;
                margin: 0 4% 0 8%;
                line-height: 1.4;
                color: #fff;
                list-style-type:disc;
                border-bottom: 1px solid rgba(255,255,255,0.3);
            }
        }
        .moreNews {
            width: 2.09rem;
            height: 0.56rem;
            display: inline-block;
            margin-top: 0.5rem;
            border-radius: 0.27rem;
            border: 1px solid #fff;
            font-size: 0.27rem;
            text-align: center;
            line-height: 0.58rem;
            a {
                color: #fff;
                text-decoration: none;
            }
        }
    }
    .arrowDown {
        position: absolute;
        bottom: 0.48rem;
        left: 0;
        right: 0;
        width: 0.28rem;
        margin: auto;
        animation: rotation 0.8s infinite alternate-reverse;
    }
    .secondPage {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-image: url(../img/m/m_bg.png);
        background-size: cover;
    }
}
@-webkit-keyframes rotation {
    from {transform: translateY(0)}
    to   {transform: translateY(5px)}
}
</style>
